"use strict";
/**
 * Environment variable utilities -- fail-fast, no silent fallbacks.
 *
 * Every Lambda handler must have its required env vars set by CDK.
 * If a var is missing, we crash immediately with a clear message
 * so the error is obvious in CloudWatch logs and surfaced to the
 * LLM when AI tools are involved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireEnv = requireEnv;
/**
 * Require an environment variable. Throws immediately if not set.
 *
 * @param name - The environment variable name
 * @returns The value of the environment variable
 * @throws Error with a clear message identifying the missing variable
 */
function requireEnv(name) {
    const value = process.env[name];
    if (!value) {
        const msg = `FATAL: Required environment variable '${name}' is not set. This usually means the Lambda is misconfigured or CDK deployment is incomplete. Check infrastructure/lib/lambda-stack.ts environment config.`;
        console.error(msg);
        throw new Error(msg);
    }
    return value;
}
//# sourceMappingURL=env.js.map